import apiClient from './api_client_requests';

export default async (payload) => {
    let result = await apiClient.apiMethod({
        method: 'MyEntries',
        args: {
            ...payload,
        },
    });

    return {
        entries: result.myentries,
        drawings: result.drawings,
        grandPrizePoints: result.grandprizepoints,
        currentPoints: result.currentpoints,
        promotionId: result.promotionid,
        page: result.page,
        totalRecords: result.totalrecords,
    };
};
